<template>
  <div id="overview-page">
    <div class="d-flex justify-end">
      <div class="mx-8 my-4">
        <div class="d-flex justify-end">
          <span class="black--text font-weight-bold" style='font-family:"MS Pゴシック", sans-serif !important; font-size: 11px'>Confidential</span>
        </div>
        <v-img :src="require('@/assets/images/report_header.png')" width="120px" eager></v-img>
      </div>
    </div>
    <div class="ma-10 mt-0" style="height: 930px;">
      <p class="font-weight-bold text-h5">1. 概要</p>
      <div>
        <v-data-table
            hide-default-footer
            disable-sort
            :items="plantInfo"
            :headers="plantTableHeaders"
        >
          <template v-slot:item.property="props">
            {{ props.item.property }}
          </template>
          <template v-slot:item.value="props">
            <div v-if="!editMode">
              <span v-if="props.item.value !== 'plantModuleModel' && props.item.value !== 'plantModuleMaker' && props.item.value !== 'plantDC' && props.item.value !== 'plantAC'">
                {{ plantInfoValue[props.item.value] ? plantInfoValue[props.item.value].toLocaleString('en-US', {maximumFractionDigits:2}) : plantInfoValue[props.item.value] }}
              </span>
              <p
                  class="mb-0 py-2"
                  v-else-if="props.item.value !== 'plantDC' && props.item.value !== 'plantAC'"
                  v-html="displayText(plantInfoValue[props.item.value])"
              >
              </p>
              <span v-else-if="plantInfoValue[props.item.value]">{{ Number(plantInfoValue[props.item.value]).toLocaleString('en-US', {maximumFractionDigits:2}) }} kW</span>
              <span v-if="props.item.value === 'plantModuleNum' && plantInfoValue[props.item.value]"> 枚</span>
            </div>
            <v-text-field
                :ref="`plantInfoInput_${plantInfo.indexOf(props.item)}`"
                v-else-if="props.item.value !== 'plantModuleModel' && props.item.value !== 'plantModuleMaker'"
                dense
                hide-details
                :hint="inputHint[props.item.type]"
                v-model="plantInfoValue[props.item.value]"
                single-line
                outlined
                :type="props.item.type"
                @blur="savePlantInfo(props.item.value)"
                @change="removePlantInputFocus(plantInfo.indexOf(props.item))"
            >
            </v-text-field>
            <v-textarea
                v-model="plantInfoValue[props.item.value]"
                v-else
                rows="1"
                outlined
                auto-grow
                hide-details
                @change="savePlantModuleInfo(props.item.value)"
            >
            </v-textarea>
          </template>
        </v-data-table>
        <hr style="display: block; height: 1px; border: 0; border-top: 1px solid rgba(0,0,0,0.12);">
      </div>
      <div class="mt-6">
        <v-data-table
            hide-default-footer
            disable-sort
            :items="shootingInfo"
            :headers="shootingTableHeaders"
        >
          <template v-slot:item.property="props">
            {{ props.item.property }}
          </template>
          <template v-slot:item.value="props">
            <span v-if="!editMode">{{ convertToDisplay(props.item.value) }}</span>
            <v-text-field
                :ref="`shootingInfoInput_${shootingInfo.indexOf(props.item)}`"
                v-else
                :hint="inputHint[props.item.type]"
                v-model="shootingInfoValue[props.item.value]"
                single-line
                dense
                outlined
                hide-details
                :type="props.item.type"
                @blur="saveShootingInfo(props.item.value)"
                @change="removeShootingInputFocus(shootingInfo.indexOf(props.item))"
            ></v-text-field>
            <span v-if="!editMode && props.item.value === 'solarRadiation'" v-html="shootingInfoValue[props.item.value]"></span>
          </template>
        </v-data-table>
        <hr style="display: block; height: 1px; border: 0; border-top: 1px solid rgba(0,0,0,0.12);">
      </div>
    </div>
    <div class="mr-8">
      <div class="d-flex align-end justify-end">
        <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 12px">‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐</span>
        <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 12px">3/{{ naviVisibleList.length + pdfPageNum + cropImagePageNum + 1}}</span>
      </div>
      <div class="d-flex align-end justify-end">
        <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 11px">Copyright East Engineering Co., Ltd. all rights reserved</span>
      </div>
    </div>
  </div>
</template>

<script>
import {store} from "@/store";

export default {
  name: "OverviewPage",
  props: ['report', 'naviVisibleList', 'cropImagePageNum', 'editMode', 'pdfPageNum'],
  data() {
    return {
      folderUuid: this.$route.params.folderUuid,
      plantTableHeaders: [
        {text: '発電所情報', value: 'property', width: '30%', class: 'font-weight-bold text-subtitle-1'},
        {value: 'value', width: '70%'},
      ],
      plantInfo: [
        {
          property: '発電所名',
          value: 'plantName',
          type: 'text'
        },
        {
          property: '所在地',
          value: 'plantAddress',
          type: 'text'
        },
        {
          property: '公称システム出力(DC)',
          value: 'plantDC',
          type: 'number'
        },
        {
          property: '定格システム出力(AC)',
          value: 'plantAC',
          type: 'number'
        },
        {
          property: 'モジュール枚数',
          value: 'plantModuleNum',
          type: 'number'
        },
        {
          property: '太陽電池モジュール',
          value: 'plantModuleModel',
          type: 'text'
        },
        {
          property: 'モジュールメーカー',
          value: 'plantModuleMaker',
          type: 'text'
        }
      ],
      plantInfoValue: {
        'plantName': null,
        'plantAddress': null,
        'plantDC': 0,
        'plantAC': 0,
        'plantModuleNum': null,
        'stringErrorModuleNum': 0,
        'plantModuleModel': null,
        'plantModuleMaker': null,
      },
      shootingTableHeaders: [
        {text: '撮影条件', value: 'property', width: '30%', class: 'font-weight-bold text-subtitle-1'},
        {value: 'value', width: '70%'},
      ],
      shootingInfo: [
        {
          property: '撮影日',
          value: 'shootingDate',
          type: 'date'
        },
        {
          property: '日射条件',
          value: 'solarRadiation',
          type: 'text'
        },
        {
          property: '撮影者',
          value: 'creator',
          type: 'text'
        }
      ],
      shootingInfoValue: {
        'shootingDate': null,
        'solarRadiation': "200W/m<sup><small>2</small></sup>を上回っていること。",
        'creator': null
      },
      shootingDateDisplay: null,
      inputHint: {
        text: 'テキストを入力してください。',
        number: '数字を入力してください。',
        date: '日付を入力してください。'
      },
      changed: false,
    }
  },

  methods: {
    init() {
      this.plantInfoValue['plantName'] = this.report.plant_name;
      this.plantInfoValue['plantAddress'] = this.report.plant_address;
      this.plantInfoValue['plantDC'] = this.report.plant_dc;
      this.plantInfoValue['plantAC'] = this.report.plant_ac;
      this.plantInfoValue['plantModuleNum'] = this.report.plant_module_num;
      this.plantInfoValue['stringErrorModuleNum'] = this.report.string_error_module_num ? this.report.string_error_module_num : 0;
      this.plantInfoValue['plantModuleModel'] = this.report.plant_module_model;
      this.plantInfoValue['plantModuleMaker'] = this.report.plant_module_maker;

      this.shootingInfoValue['shootingDate'] = this.report.shooting_date ? this.report.shooting_date.split(' ')[0] : '';
      this.shootingInfoValue['solarRadiation'] = this.report.solar_radiation ? this.report.solar_radiation : "200W/m<sup><small>2</small></sup>を上回っていること。";
      this.shootingInfoValue['creator'] = this.report.creator;
    },
    savePlantInfo(value) {
      if (!this.plantInfoValue[value] && value === 'stringErrorModuleNum'){
        this.plantInfoValue[value] = 0;
      }
      if (this.changed){
        this.axios
            .put('/api/report/' + this.folderUuid, {
              property: value,
              value: this.plantInfoValue[value],
            }).then(() => {
              this.report[value] = this.plantInfoValue[value];
            }).catch(() => {
              this.getReport();
              store.showErrorDialog('エラーが発生しました。再度試してください。');
            });
        this.changed = false;
      }
    },
    saveShootingInfo(value) {
      if (this.changed){
        this.axios
            .put('/api/report/' + this.folderUuid, {
              property: value,
              value: this.shootingInfoValue[value],
            })
            .catch(() => {
              this.getReport();
              store.showErrorDialog('エラーが発生しました。再度試してください。');
            });
        this.changed = false;
      }
    },
    convertToDisplay(value) {
      if (this.shootingInfoValue[value] && value === 'shootingDate') {
        const d = new Date(this.shootingInfoValue[value]);
        return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`;
      }
      if (value !== 'solarRadiation') return this.shootingInfoValue[value];
      else return null;
    },
    removePlantInputFocus(index){
      this.changed = true;
      this.$refs[`plantInfoInput_${index}`].blur();
    },
    removeShootingInputFocus(index){
      this.changed = true;
      this.$refs[`shootingInfoInput_${index}`].blur();
    },
    displayText(text){
      if (text){
        return text.replaceAll('\n', '<br>');
      }
      else return null;
    },
    savePlantModuleInfo(value){
      this.axios
          .put('/api/report/' + this.folderUuid, {
            property: value,
            value: this.plantInfoValue[value],
          }).then(() => {
            this.report[value] = this.plantInfoValue[value];
          }).catch(() => {
            this.getReport();
            store.showErrorDialog('エラーが発生しました。再度試してください。');
          });
    }
  },

  created() {
    this.init();
  },
}
</script>

<style scoped>
>>> .v-input__slot::before {
  border-style: none !important;
}
>>> .v-input{
  font-size: 14px !important;
}
>>>.v-textarea textarea{
  margin-top: 0px !important;
  line-height: 1.5;
}
</style>
